import React from 'react';
import {
  Button,
  ButtonProps,
  createStyles,
  withStyles,
  IconButton as MuiIconButton,
  IconButtonProps,
  Link as MuiLink,
  LinkProps as MuiLinkProps,
} from '@material-ui/core';
import { LinkProps } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';

import {
  primaryGreen,
  hoverGreen,
  hoverSecondaryGreen,
  darkGreen,
  black,
  typographyColorKeys,
} from 'src/data/colors';

export type UIButtonProps = Omit<ButtonProps, 'variant' | 'color'> & {
  component?: React.ElementType; // TODO: for some reason, the component prop is not working
  to?: LinkProps['to']; // TODO: check if there is a better way to do this
};

export const PrimaryButton = withStyles(() =>
  createStyles({
    root: {
      backgroundColor: primaryGreen,
      fontWeight: 500,
      textTransform: 'uppercase',

      '&:hover': {
        backgroundColor: hoverGreen,
      },
    },
  })
)((props: UIButtonProps) => (
  <Button {...props} variant="contained" color="primary" />
)) as React.FC<UIButtonProps>;

export const SecondaryButton = withStyles(() =>
  createStyles({
    root: {
      border: `1px solid ${primaryGreen}`,
      borderRadius: 4,
      color: primaryGreen,
      fontWeight: 500,
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: hoverSecondaryGreen,
        border: `1px solid ${primaryGreen}`,
        color: 'white',
      },
    },
  })
)((props: UIButtonProps) => <Button {...props} variant="outlined" color="primary" />);

export const PrimaryTextButton = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 500,
      textTransform: 'uppercase',
      color: primaryGreen,
    },
  })
)((props: UIButtonProps) => <Button {...props} variant="text" color="primary" />);

export const SecondaryTextButton = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 500,
      textTransform: 'uppercase',
      color: darkGreen,
    },
  })
)((props: UIButtonProps) => <Button {...props} variant="text" color="primary" />);

export const CancelButton = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 400,
      backgroundColor: '#f0f0f0',
    },
  })
)((props: UIButtonProps) => <Button {...props} variant="contained" color="default" />);

export const PrimaryActionButton = PrimaryButton;

export const SecondaryActionButton = SecondaryButton;

export const PrimaryIconButton = withStyles(() =>
  createStyles({
    root: {
      backgroundColor: primaryGreen,
      color: 'white',
      '&:hover': {
        backgroundColor: hoverGreen,
      },
    },
  })
)((props: IconButtonProps) => <MuiIconButton {...props} />);

export const SecondaryIconButton = withStyles(() =>
  createStyles({
    root: {
      border: `1px solid ${primaryGreen}`,
      color: primaryGreen,
      '&:hover': {
        backgroundColor: hoverSecondaryGreen,
        border: `1px solid ${primaryGreen}`,
        color: 'white',
      },
    },
  })
)((props: IconButtonProps) => <MuiIconButton {...props} />);

export const GhostIconButton = withStyles(() =>
  createStyles({
    root: {
      border: 'none',
    },
  })
)((props: IconButtonProps) => <MuiIconButton {...props} />);

const StyledLink = styled(MuiLink)({
  textDecoration: 'none',
  cursor: 'pointer',
  '& :hover': {
    color: primaryGreen,
  },
});

export const LinkButton = (
  props: Omit<MuiLinkProps, 'color'> & { color?: keyof typeof typographyColorKeys }
) => {
  const { color, ...rest } = props;
  return <StyledLink {...rest} style={{ color: color ? typographyColorKeys[color] : black }} />;
};
